import { DashboardList } from '@/common/stores/dashboard-popup';
import { DetailInfoData } from '@/common/utils';
import { DashboardKey } from '@/common/uses/useDashboardJump';
import { computed } from 'vue';
import { useMyInfoStore } from '@/config/stores/my-info';
import { getTzTimeNow } from '@/common/utils/time.utils';
import { openSafeUrl } from '@/common/utils/browser/navigation';

export interface Props {
  dashboardList: DashboardList[];
  moveDashboard: (id: number, keyInfo?: DashboardKey) => void;
  keyInfo?: DashboardKey;
  infoDataList?: DetailInfoData[];
}

interface DashboardItem extends DashboardList {
  icon: string;
}

const getIconType = (isDashboard: boolean, isNewWindow: boolean) => {
  const icon = {
    dashboard: 'icon-dashboard-regular',
    link: 'icon-link-chain',
    linkNew: 'icon-send-copy',
  };

  if (isDashboard) {
    return icon.dashboard;
  }
  return isNewWindow ? icon.linkNew : icon.link;
};

const setup = (props: Props) => {
  const selectedList = computed<DashboardItem[]>(() => {
    return (
      props.dashboardList?.map((item) => {
        return {
          ...item,
          icon: getIconType(!!item.dashboardId, item.isNewWindow ?? false),
        };
      }) ?? []
    );
  });

  const onClickDashboardList = (list: DashboardItem) => {
    if (list.dashboardId) {
      props.moveDashboard(list.dashboardId, props.keyInfo);
    } else {
      if (!list.url) {
        return;
      }

      const { myInfo: accountInfo } = useMyInfoStore();
      const containerKey = props.infoDataList?.filter((data) => data.field === 'containerKey')[0]
        ?.values[0];
      const today = getTzTimeNow();

      const url = list.url
        .replace('$intermaxFromTime', `${+today.subtract(10, 'minutes')}`)
        .replace('$intermaxToTime', `${+today}`)
        .replace('$timeZone', accountInfo.timezone ?? '')
        .replace('$containerId', containerKey ?? '');

      openSafeUrl(url, { newWindow: list.isNewWindow });
    }
  };

  return {
    selectedList,
    onClickDashboardList,
  };
};

export { setup };
